import { hc } from 'hono/client'
import type { SupportClient } from '#app/server/support/api.support'

export const supportClient = hc<SupportClient>('/_support')
